import React from 'react';
import ManagerInsuranceCompaniesCaseTypeModal from './ManagerInsuranceCompaniesCaseTypeModal';
import { useDisclose } from '../../../../../Modal/Hooks/useDisclose';
import { Theme } from '../../../../../../Enums/Theme.enum';
import LinkButton from '../../../../../../Components/Button/LinkButton';

interface Props {
	id: string;
}

const ManagerInsuranceCompaniesCaseTypeOpen = ({ id }: Props) => {
	const { isOpen, onOpen, onClose } = useDisclose();

	return (
		<>
			<LinkButton
				title='base.shared.show'
				theme={Theme.BLUE}
				onClick={onOpen}
			/>
			{isOpen && (
				<ManagerInsuranceCompaniesCaseTypeModal
					isOpen
					onClose={onClose}
					caseTypeId={id}
				/>
			)}
		</>
	);
};

export default ManagerInsuranceCompaniesCaseTypeOpen;
